export default __webpack_public_path__ + "static/media/logo.4be58ef9.png";